import { Skeleton } from '@/components/ui/skeleton'

export function GroupLoginPending() {
  return (
    <div className="flex flex-col items-center gap-3 text-center">
      <div className="flex flex-col items-center gap-1">
        <Skeleton className="h-7 w-14" />
        <Skeleton className="h-6 w-20" />
      </div>
    </div>
  )
}
